import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import NumberKeyboard from '@components/common/formElements/SimpleKeyboard/numberKeyboard';
import { getObjectValue, urlSearchParams } from '../../utility/utills';
import { flowType } from '@utility/userInfo';
import styles from './receiptScreen.module.scss';
import { findIndex } from 'lodash';
const ReceiptScreen = ({
  tableData,
  currenySymbol,
  renderModifier,
  paymentType,
  tipAmount,
  // paymentAmount,
  active,
  isKiosk,
  handleButtonClick,
  handleKeyboardValue,
  keyboardValue,
  paymentFlowType,
  paidTips = 0,
  unpaidTips = 0,
  countryCode,
  // successMessage,
  // authResponse,
  fontSize = 'fs-24',
  supportsTips,
  paymentCheck,
  noRoundedBorder,
  deviceInfo,
  // charityAmount,
  // charityList,
  // charity,
  allMenuItems,
  ShowLandscapeMode,
  tipInfo,
}) => {
  const serviceChargeAmount = getObjectValue(() => tableData.serviceChargeAmount, 0);
  const discountAmount = getObjectValue(() => tableData.discountAmount, 0);
  const isDefaultMode = getObjectValue(() => (!deviceInfo.deviceGroup || [0].includes(deviceInfo.deviceGroup.startMode)), false);
  const payType = new URLSearchParams(window.location.search).get('type');
  const paymentScreen = Number(urlSearchParams('screenType')) || 1;
  const [tableValueData, setTableValueData ]= useState([]);

  useEffect(() => {
    // console.log("paymentScreen",paymentScreen,"payType",payType)
    if (payType === 'stage' && paymentScreen === 17) {
      tableData?.paymentStages.forEach((paymentStageData, i) => {
      const itemsArray = [];
      let subTotalAmount = 0;
      tableData?.items.forEach((it) => {
        let price = 0;
        let flag = false;
        let count = 0;
        paymentStageData?.seats.forEach((nSeat) => {
          const index = findIndex(it.seats, (d) => d.seatId === nSeat.seatId);
          if (index !== -1) {
            flag = true;
            count += 1;
            price += it.seats[index].splitAmount;
          }
        });
        if (flag) {
          subTotalAmount += price;
          itemsArray.push({
            ...it,
            oldPrice: it.price,
            price,
            splitValueString: count === it.seats.length ? '' : `${count}/${it.seats.length} `
          });
        }
      });
      setTableValueData(itemsArray);
    });
  }
  },[payType,paymentScreen]);

  const getItemSplitValue = (item) => {
    let splitStringValue = '';
    tableValueData.forEach((it)=> {
      if(it?.menuItemId === item?.menuItemId) {
        splitStringValue = it.splitValueString
      } 
    });
    return splitStringValue;
  }

  const excludeItemFromReceiptScreen = (item) => {
     let excludeProduct = false; 
    allMenuItems?.forEach((insideItems)=> {
      if(insideItems.id === item.menuItemId && insideItems?.excludeFromReceipt) {
        excludeProduct =  true;
      }
    })
    return excludeProduct;
  }

  
  const isTableTop = flowType() === 'tableTop';
  const isCounter = getObjectValue(() => [1].includes(deviceInfo.deviceGroup.startMode), false);
  const taxAmoutWithTotal = isCounter && (Number(urlSearchParams('screenType')) === 16) ? Number(tableData?.totalAmount) + Number(tableData?.taxAmount) : tableData.totalAmount;

  return (
    <>
      {![6, 7, 8, 4, 13, 24, 25, isCounter? '': 3].includes(paymentType) && (
        <>
          {countryCode !=='44' && paymentFlowType !== 1 && payType !== 'payType' && paymentType !== 1 && Number(urlSearchParams('screenType')) !== 1 && Number(urlSearchParams('screenType')) !== 9 && Number(urlSearchParams('screenType')) !== 10 && Number(urlSearchParams('screenType')) !== 17 && Number(urlSearchParams('screenType')) !== 18 && !isCounter ? <div className={cn((isKiosk || isTableTop) ? 'd-none' : 'h-5 text-center py-0 od-text-primary text-primary w-100')}>{LABEL().STAGE}:{tableData?.stage?.code} {tableData?.stage?.name ? <span>(<span className={styles.truncate}> {tableData.stage.name}</span>)</span> : tableData?.stage?.name}</div> : null}
          {tableData.items && tableData.items.length > 0 ? (
            <div className={cn('col-12 pt-4 w-100 border-bottom border-color-primary od-text-primary text-primary overflowY', (isTableTop || isKiosk || ShowLandscapeMode || [23].includes(paymentType)) ? 'h-60 p-2' : 'h-80 p-2', { 'px-2 pt-4 pb-2': isTableTop && !noRoundedBorder })}>
              {tableData?.items?.map((item) => {
                const excludeFromReceipt = excludeItemFromReceiptScreen(item);
                return (
                     <>
                      {!excludeFromReceipt && 
                        <div key={item.menuItemId} className="row m-0">
                        <div className="col-9 p-0 text-left fs-18">
                          <div className="row mx-0">
                          { [2,17,23].includes(paymentType) && !(['payType',  'null', 'credit'].includes(payType)) ? (<span className={cn('col-10 p-0 fs-16 fw-700', item.quantity > 1 || tableData.splitValue > 1 ? 'col-4' : '')}>
                            { `${(item.quantity > 1 || tableData.splitValue > 1) ? `${item.quantity}${tableData.splitValue > 1 ? `/${tableData.splitValue} ` : ''}x ` : ''}`}{`${item.splitValueString ? item.splitValueString : getItemSplitValue(item)}${item.menuItemName}`}
                            </span> ) :
                             <span className={cn('p-0', styles.spanForPayment, item.quantity > 1 || tableData.splitValue > 1 ? '' : 'col-11')}>
                              {item.quantity > 1 ? item.quantity + ' x ' : ''}  {item.menuItemName} 
                            </span> }
                          </div>
                        </div>
                        <div className={cn('col-3 p-0  fs-18 text-right', styles.divForPayment)}>
                          {currenySymbol}{(item.price).toFixed(2)}
                        </div>
                        <div className="col-12 p-0">
                          {item.modifiers && renderModifier(item.modifiers)}
                          {/* <div className="text-left pl-2 fs-18">
                            {`${item.note ? `- ${item.note}` : ''}`}
                          </div> */}
                        </div>
                      </div>
                      }
                    </>
                );
              })}
            </div>
          ) : <div className="h-55 d-flex col-12 px-3 py-1 border-bottom border-color-primary od-text-primary text-primary overflowY fs-600 justify-content-center align-items-center fs-26">{CUSTOM_MESSAGES().NO_ITEM_FOUND}</div>}
          <div className={cn('col-12 border-color-primary od-text-primary text-primary overflowY mx-0 px-0 mt-4',(ShowLandscapeMode || [23].includes(paymentType)) ? 'h-40' : 'h-20')}>
            {/* <div className="row mx-0 fw-700 fs-20">
              <div className="col-8 p-0 text-left">{LABEL().SUB_TOTAL}</div>
              <div className="col-4 p-0 fs-20 text-right">
                {currenySymbol} {(tableData.subTotalAmount || tableData.subTotalAmount === 0) && tableData.subTotalAmount.toFixed(2)}
              </div>
            </div> */}
            {countryCode === '44' ? (
              <div className="row m-0 fw-700 fs-18">
                <div className="col-8 p-0 text-left">{LABEL().PAYEMENT_TOTAL_DUE}</div>
                {Number(urlSearchParams('screenType')) === 5
                  ? (
                    <div className="col-4 p-0 text-right">
                      {currenySymbol}{(tableData.totalAmount - tipAmount).toFixed(2)}
                    </div>
                  )
                  : (
                    <div className="col-4 p-0 text-right">
                      {currenySymbol}{(tableData.totalAmount || tableData.totalAmount === 0) && countryCode != 44 ? 
                      (taxAmoutWithTotal).toFixed(2):
                      Number(urlSearchParams('screenType')) !== 17 ? 
                        urlSearchParams('type') != 'payType' ? Number(urlSearchParams('screenType')) === 1 ? (taxAmoutWithTotal).toFixed(2) : countryCode === '44' ? urlSearchParams('type')=='stage' ? taxAmoutWithTotal.toFixed(2) : Number(urlSearchParams('screenType')) === 2 || Number(urlSearchParams('screenType')) === 18? taxAmoutWithTotal.toFixed(2) : (taxAmoutWithTotal).toFixed(2) : taxAmoutWithTotal.toFixed(2) :
                       (taxAmoutWithTotal).toFixed(2) :
                       Number(urlSearchParams('screenType')) === 17 ?
                      taxAmoutWithTotal.toFixed(2) : 
                      (taxAmoutWithTotal).toFixed(2)}
                    </div>
                  )}
              </div>
            ) : (
              <div className="row mx-0 fw-700 fs-18">
                  <div className={cn('col-6 p-0 text-left', styles.divForPayment)}>{LABEL().SUB_TOTAL}</div>
                  <div className={cn('col-6 p-0 text-right', styles.divForPayment)}>
                  {currenySymbol}{(tableData.subTotalAmount || tableData.subTotalAmount === 0) && tableData.subTotalAmount.toFixed(2)}
                </div>
              </div>  
            )}
            <div className="row mx-0 fw-700 fs-18">
              <div className={cn('col-6 p-0 text-left', styles.divForPayment)}>{countryCode === '44' ? LABEL().VAT : LABEL().TAX}</div>
              <div className={cn('col-6 p-0 text-right', styles.divForPayment)}>
                {currenySymbol}{(tableData.taxAmount || tableData.taxAmount === 0) && tableData.taxAmount.toFixed(2)}
              </div>
            </div>
            {discountAmount > 0 && (
              <div className="row mx-0 fw-700 fs-18">
                <div className="col-6 p-0 text-left">{LABEL().DISCOUNT_AMOUNT}</div>
                <div className={cn('col-6 p-0 text-right', styles.divForPayment)}>
                  -{currenySymbol}{discountAmount.toFixed(2)}
                </div>
              </div>
            )}
            {serviceChargeAmount > 0 && (
              <div className="row mx-0 fw-700 fs-18">
                <div className="col-6 p-0 text-left">{LABEL().SERVICE_CHARGE}</div>
                <div className={cn('col-6 p-0 text-right', styles.divForPayment)}>
                  {currenySymbol}{serviceChargeAmount.toFixed(2)}
                </div>
              </div>
            )}
            {[1, 20, 17].includes(paymentType) && getObjectValue(() => tipAmount > 0, false) && (
              <div className="row m-0 fw-700 fs-18">
                <div className={cn('col-6 p-0 text-left', styles.divForPayment)}>{LABEL().TIP}</div>
                <div className={cn('col-6 p-0 text-right', styles.divForPayment)}>
                  {currenySymbol}{(tipAmount && Number(tipAmount).toFixed(2)) || (tableData?.tipAmount.toFixed(2))}
                </div>
              </div>
            )}
            {countryCode !== '44' && ![20, 17, 18].includes(paymentType) && (
              <div className="row mx-0 fw-700 fs-18 align-items-center">
                <div className={cn('col-6 p-0 text-left fs-30',styles.divForPayment)}>{LABEL().PAYEMENT_TOTAL_DUE}</div>
                <div className={cn(isKiosk || isTableTop || deviceInfo?.deviceGroup?.startMode === 0 ? 'col-6 p-0 text-right fs-30' : 'col-6 p-0 text-right', styles.divForPayment)}>
                  {currenySymbol}{(tableData.totalAmount || tableData.totalAmount === 0) && tableData.totalAmount.toFixed(2)}
                </div>
              </div>
            )}
            {(getObjectValue(() => tableData.paidAmount > 0, false) && ![5].includes(paymentType)) && (
              <div className="row m-0 fw-700 fs-18">
                <div className={cn('col-6 p-0 text-left', styles.divForPayment)}>{LABEL().TOTAL_PAID}</div>
                <div className={cn('col-6 p-0 text-right', styles.divForPayment)}>
                  {currenySymbol}{tableData.paidAmount.toFixed(2)}
                </div>
              </div>
            )}
            {getObjectValue(() => paidTips > 0, false) && [1, 2, 10, 9].includes(paymentType) && (
              <div className="row m-0 fw-700 fs-18">
                <div className="col-6 p-0 text-left">{LABEL().PAID_TIPS} </div>
                <div className={cn('col-6 p-0 text-right')}>
                  {currenySymbol}{Number(paidTips).toFixed(2)}
                </div>
              </div>
            )}
            {getObjectValue(() => unpaidTips > 0, false) && [1, 2, 10, 9].includes(paymentType) && (
              <div className="row m-0 fw-700 fs-18">
                <div className="col-6 p-0 text-left">{LABEL().UNPAID_TIPS} </div>
                <div className={cn('col-6 p-0 text-right', styles.divForPayment)}>
                  {currenySymbol}{Number(unpaidTips).toFixed(2)}
                </div>
              </div>
            )}
            {[2, 5, 6, 11, 12].includes(paymentType) && paymentFlowType === 4 && getObjectValue(() => tipAmount > 0, false) && (
              <div className="row m-0 fw-700 fs-18">
                <div className={cn('col-6 p-0 text-left', styles.divForPayment)}>{LABEL().TIP}</div>
                <div className={cn('col-6 p-0 text-right')}>
                  {currenySymbol}{(tipAmount && Number(tipAmount).toFixed(2)) || (tableData?.tipAmount.toFixed(2))}
                </div>
              </div>
            )}
            {[2, 3, 4, 5, 6, 11, 12].includes(paymentType) && paymentFlowType === 3 && getObjectValue(() => tipAmount > 0, false) && (
              <div className="row m-0 fw-700 fs-18">
                <div className="col-6 p-0 text-left">{LABEL().TIP} </div>
                <div className={cn('col-6 p-0 text-right', styles.divForPayment)}>
                  {currenySymbol}{(tipAmount && Number(tipAmount).toFixed(2)) || (tableData?.tipAmount.toFixed(2))}
                </div>
              </div>
            )}
            {tipInfo !== null && [23].includes(paymentType) ? <div className="row m-0 fw-700 fs-18">
              <div className={cn('col-6 p-0 text-left', styles.divForPayment)}>{LABEL().TIP}</div>
              <div className={cn('col-6 p-0 text-right', styles.divForPayment)}>
                  {currenySymbol}{(tipAmount && Number(tipAmount).toFixed(2)) || (tableData?.tipAmount.toFixed(2))}
                </div>
              </div> : null}
              
            {[5, 6, 11].includes(paymentType) && (
              <div className="row m-0 fw-700 fs-18">
                <div className="col-6 p-0 text-left">{LABEL().PAYMENT} </div>
                {countryCode === '44' && Number(urlSearchParams('screenType')) === 5
                  ? (
                    <div className="col-4 p-0 text-right">
                      {currenySymbol}{tableData?.totalAmount?.toFixed(2)}
                    </div>


                  )
                  : (
                    <div className="col-4 p-0 text-right">
                      {currenySymbol}{tableData && (tableData.totalAmount + Number(tipAmount)).toFixed(2)}
                    </div>
                  )}
              </div>
            )}
          </div>
          {isKiosk && <div className={cn('col-12 od-header background-primary w-100 row mx-0 justify-content-center align-items-center fw-600 od-color h-10', fontSize)} style={{ borderBottomLeftRadius: '5px', borderBottomRightRadius: '5px' }}>
            {[5, 6, 11, 17, 18, 20].includes(paymentType) ? (
              <>
                {countryCode === '44' && Number(urlSearchParams('screenType')) === 5
                  ? (
                    <>
                      {isKiosk ? LABEL().PAYMENT_COMPLETED : LABEL().TOTAL_PAYMENT_PAID}: {currenySymbol}{(tableData?.totalAmount)?.toFixed(2)}
                    </>
                  )
                  : (
                    <>
                     {isKiosk ? urlSearchParams('type') == 'payatcounter' ? LABEL().PAYMENT_DUE :  LABEL().PAYMENT_COMPLETED : LABEL().TOTAL_PAYMENT_PAID}: {currenySymbol}{tableData && (tableData.totalAmount + Number(tipAmount))?.toFixed(2)}                    </>
                  )}
              </>
            ) : (
              <>
                {isKiosk ? LABEL().PAYMENT_DUE : LABEL().TOTAL_DUE_PAYMENT}: {currenySymbol}{tableData && !isDefaultMode && countryCode === '44' ? (Number(tableData.totalAmount) + Number(tableData.taxAmount) - tableData.paidAmount + Number(tipAmount) + Number(unpaidTips)).toFixed(2) : (Number((tableData.totalAmount)).toFixed(2) - tableData.paidAmount + Number(tipAmount) + Number(unpaidTips)).toFixed(2)}
              </>
            )}
          </div>}
        </>
      )}
      {[7, 8].includes(paymentType) && (
        <div className="col-12 row fs-12 m-0 align-items-center text-center">
          <div className="col-12" style={ isCounter ? { fontSize: '4rem', top: '' } : { fontSize: '4rem', top: '40px' }} >
            <i className="fa fa-exclamation-circle text-primary" aria-hidden="true" />
            <div className="mb-2 fs-20 od-text-primary text-primary " style={{ fontSize: '34px' }}>
            </div>
          </div>
        </div>
      )}
      {[13].includes(paymentType) && (
        <div className="w-100 h-100 position-relative">
          <div className={cn('col-12 text-center h-85', { 'd-none': !supportsTips })}>
            <NumberKeyboard
              name="tipsAmount"
              haveCurrency={
                active === `Other ${LABEL().CURRENCY_SYMBOL}` ? `${LABEL().CURRENCY_SYMBOL}` : '%'
                // active === `Other ${LABEL().CURRENCY_SYMBOL}` || charityList.includes(active) || [13].includes(paymentType) ? `${LABEL().CURRENCY_SYMBOL}` : '%'
              }
              type="number"
              isDotRequired
              value={active === `${LABEL().ROUND_UP}` ? '' : keyboardValue}
              onChange={(e) => {
                handleKeyboardValue(e);
                if ([`Other ${LABEL().CURRENCY_SYMBOL}`, 'Other $'].includes(active)) {
                  handleButtonClick(active, e);
                } else {
                  handleButtonClick('Other %', e);
                }
              }}
            />
          </div>
          <div
            className="col-12 p-0 position-absolute h-15 border od-text-primary od-container-card-background background-secondary border-color-secondary overflowY fs-12"
            style={{
              bottom: '0px',
              left: '0px',
              borderBottomLeftRadius: '5px',
              borderBottomRightRadius: '5px'
            }}
          >
            {/* <div className="row mx-0 fw-700">
              <div className="col-4 text-left">{LABEL.DISCOUNT_AMOUNT}</div>
              <div className="col-8 text-right">
                {currenySymbol} {discountAmount.toFixed(2)}
              </div>
            </div>
            <div className="row mx-0 fw-700">
              <div className="col-6 text-left">{LABEL.SERVICE_CHARGE}</div>
              <div className="col-6 text-right">
                {currenySymbol} {serviceChargeAmount.toFixed(2)}
              </div>
            </div> */}
            <div className="row m-0 fw-700">
              <div className="col-4 text-left">{LABEL().PAYEMENT_TOTAL_DUE} </div>
              <div className="col-8 text-right">
                {currenySymbol}{tableData && (tableData.totalAmount - tableData.paidAmount).toFixed(2)}
              </div>
            </div>
            {/* {getObjectValue(() => (tipAmount) > 0, false) && ( */}
            <div className="row m-0 fw-700">
              <div className="col-4 text-left">{LABEL().TIP}</div>
              <div className={cn(isKiosk || isTableTop || deviceInfo?.deviceGroup?.startMode === 0 ? 'col-6 p-0 text-right' : 'col-2 p-0', styles.divForPayment)}>
                {currenySymbol}{(tipAmount && Number(tipAmount).toFixed(2)) || (tableData?.tipAmount?.toFixed(2))}
              </div>
            </div>
            <div className="row m-0 fw-700">
              <div className="col-4 text-left">{LABEL().RECEIPT_PAYMENT} </div>
              <div className="col-8 text-right">
                {currenySymbol}{(tableData && (tableData.totalAmount - tableData.paidAmount + Number(tipAmount)).toFixed(2))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReceiptScreen;
